export default {
  shareMeta: {
    title: "PixelHaha の <xx1> による写真",
    description:
      "PixelHaha の AI 画像ジェネレーターを使用して <xx1> が作成したこの無料の写真をダウンロードしてください。",
  },
  home: {
    picTitle: "無料のストック画像",
    recentSearch: "最近の検索",
    clear: "クリア",
    trendsSearch: "トレンド検索",
    details: "詳細",
    enhance: "強化する",
    reimagine: "再考する",
  },
  search: {
    guess: "あなたも気に入るかもしれない",
    trending: "トレンド",
    newest: "最新",
    empty: "検索結果はまだありません。",
    goCreate: "イメージを作成しましょう",
    searchPlaceholder: "インスピレーションはここから始まります...",
  },
  detail: {
    report: "報告",
    downloadFree: "無料でダウンロード",
    prompt: "プロンプト",
    more: "あなたも気に入るかもしれない",
    toCreate: "作成する",
    enhance: "写真の強化",
    invalid:
      "リンクは利用できません。作成者が公開をキャンセルしたか、画像が準拠していません。",
    generation: "PixelHaha は高品質の画像生成を提供します。",
    exploreMore: "さらに詳しく",
    jpg: "JPG",
    png: "PNG",
    download : "ダウンロードに失敗しました。ネットワーク接続を確認してもう一度お試しください。",
  },
  trends: {
    bgTip: "トレンド検索",
    wrong: "問題が発生しました",
    retry: "リトライ",
    top: "トップ",
    a: "A",
    b: "B",
    c: "C",
    d: "D",
    e: "E",
    f: "F",
    g: "G",
    h: "H",
    i: "I",
    j: "J",
    k: "K",
    l: "L",
    m: "M",
    n: "N",
    o: "O",
    p: "P",
    q: "Q",
    r: "R",
    s: "S",
    t: "T",
    u: "U",
    v: "V",
    w: "W",
    x: "X",
    y: "Y",
    z: "Z",
  },
  img: {
    notReviewed: "この画像はまだレビューされていません",
    posting: "投稿中...",
    deleteQ: "削除を確認しますか?",
    cancel: "キャンセル",
    delete: "消去",
  },
  ugcPage: {
    editName: "名前を編集",
    finish: "仕上げる",
    goHistory: "履歴公開へ進む",
    tabWork: "仕事",
    tabFavorites: "お気に入り",
    empty: "データなし",
    avatarTypeError: ".png、.jpg、.webp のみサポートされます",
  },
  siteMap: {
    page: "ページ",
    sort: "選別",
    keywords: "キーワード",
  },
  report: {
    title: "レポート内容",
    text: "なぜこれを報告するのですか?",
    reason1: "利用規約違反",
    reason2: "低品質",
    reason3: "スパム",
    reason4: "センシティブなコンテンツ",
    reason5: "他の",
    textplaceholder: "発見した問題をできるだけ具体的に説明してください。",
    submit: "レポートの確認",
    toastSuccess: "レポートは正常に送信されました。すぐに確認します。",
    toastFailed: "レポートの送信に失敗しました。もう一度お試しください。",
  },
};
